module.exports = __webpack_public_path__ + "img/team.f1fd19c0.png";